import { getStatusAlert } from '../utils';
import { AlertBody, AlertIcon, AlertNote, AlertRoot, AlertTitle, Mono } from './styled';
import type { StatusAlertProps } from './types';

const renderWithMono = (text: string) => {
  const tokens = [
    'scheduling_error_status_cron',
    'drug_test_org_id',
    'drug_test_location_id',
    'Collection Cancelled',
    'Deleted',
    'Expired, No Show',
    'Expired, Not Scheduled',
    'Refusal to Test',
    'Registration Expired',
  ];
  const pattern = new RegExp(`(${tokens.map((t) => t.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).join('|')})`, 'g');
  const parts = text.split(pattern);

  return parts.map((part, index) => (tokens.includes(part) ? <Mono key={`${part}-${index}`}>{part}</Mono> : part));
};

const StatusAlert = ({ report }: StatusAlertProps) => {
  const alert = getStatusAlert(report);
  if (!alert) return null;

  return (
    <AlertRoot kind={alert.kind} role="alert">
      <AlertIcon aria-hidden>{alert.icon}</AlertIcon>
      <AlertBody>
        <AlertTitle>{alert.title}</AlertTitle>
        {' — '}
        {renderWithMono(alert.message)}
        {alert.note ? <AlertNote>{renderWithMono(alert.note)}</AlertNote> : null}
      </AlertBody>
    </AlertRoot>
  );
};

export default StatusAlert;
